import { render, staticRenderFns } from "./DialogRequest.vue?vue&type=template&id=edf428f4"
import script from "./DialogRequest.vue?vue&type=script&lang=js"
export * from "./DialogRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports